const EnvironmentPageTabs = ({ data }) => {
  return (
    <>
      <div className="title-sec wow fadeIn ">
        <h2>{data?.title}</h2>
      </div>
      <div
        dangerouslySetInnerHTML={{ __html: data?.body }}
        className="ecology-tab"
      ></div>
    </>
  );
};

export default EnvironmentPageTabs;
